import { GymAddress } from './gym-address';
import { GymOffer } from './gym-offer';
import { AdditionalInfo } from './additional-info';
import { GymImage } from './gymImage';
import { Options } from './options';
import { ExternalBookingInfo } from './external-booking-info';
import { ClassBookingConfig } from './class-booking-config';
import { CreditsConfig } from './credits/credits-config';
import { TransactionalEmailsConfiguration } from './transactional-emails-configuration';
import { OpeningHoursV2 } from './opening-hours';

// Re-export all opening-hours types for convenience
export * from './opening-hours';

export enum NetworkType {
  DACH = 'DACH',
  FR_BE = 'FR_BE',
  US = 'US',
}

export enum MembershipType {
  UNLIMITED = 'UNLIMITED',
  CREDITS = 'CREDITS',
  PLUS_1 = 'PLUS_1',
}

export enum GymType {
  WELLPASS_DACH_UNLIMITED = 'WELLPASS',
  WELLPASS_DACH_PLUS1 = 'WELLPASS_PLUS1',
  WELLPASS_FR_BE_CREDITS = 'GYMLIB',
  WELLPASS_FR_BE_UNLIMITED = 'WELLPASS_FRANCE',
  WELLPASS_FR_BE_PLUS1 = 'WELLPASS_FR_BE_PLUS1',
  WELLPASS_US_UNLIMITED = 'WELLPASS_US',
}

const PLUS1_TYPES = new Set([
  GymType.WELLPASS_DACH_PLUS1,
  GymType.WELLPASS_FR_BE_PLUS1,
]);

export function hasGymTypesChanged(
  currentTypes: string[] | undefined,
  originalTypes: string[] | undefined
): boolean {
  if (!originalTypes || originalTypes.length === 0) {
    return false;
  }

  const normalize = (types?: string[]) =>
    (types ?? [])
      .filter(t => !PLUS1_TYPES.has(t as GymType))
      .sort((a, b) => a.localeCompare(b));

  const current = normalize(currentTypes);
  const original = normalize(originalTypes);

  return (
    current.length !== original.length ||
    current.some((type, i) => type !== original[i])
  );
}

export class Gym {
  id: string;
  gymId?: number;
  gymUUID?: string;
  gymChainId?: number;
  gymChainUUID?: string;
  gymChainName?: string;
  alias?: string;
  slug?: string;
  description?: string;
  qualitrainOfferDescription?: string;
  studioType?: string;
  offers?: GymOffer[];
  options: Options;
  additionalInfo: AdditionalInfo;
  openingHoursV2: OpeningHoursV2;
  gymImages: GymImage[];
  address: GymAddress;
  email?: string;
  phone?: string;
  website?: string;
  profilePagePublic: boolean;
  accessDescription?: string;
  timezone?: string;
  instagram?: string;
  externalBookingInfo?: ExternalBookingInfo;
  visibleInBusinessSuite: boolean;
  disableStudioPageEditing: boolean;
  classBookingConfig: ClassBookingConfig;
  creditsConfig: CreditsConfig;
  network: NetworkType;
  geofence?: number | null;
  tanAccountCreationEnabled?: boolean;
  locale?: string;
  transactionalEmailsConfiguration?: TransactionalEmailsConfiguration | null;
  timestampUpdate?: number;
}
